import { createBrowserRouter } from 'react-router';
import { RootLayout } from './root-layout';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        lazy: () => import('./home'),
      },
      {
        path: 'zania-exchange-hub',
        lazy: () => import('./home'),
      },
      {
        path: 'hub',
        lazy: () => import('./hub'),
      },
      {
        path: 'rooms/:roomId',
        lazy: () => import('./room-layout'),
        children: [
          {
            index: true,
            lazy: () => import('./room-detail'),
          },
        ],
      },
      {
        path: 'followup',
        lazy: () => import('./followup'),
      },
      {
        path: 'expired',
        lazy: () => import('./expired'),
      },
      {
        path: 'submitted',
        lazy: () => import('./submitted'),
      },
      {
        path: '*',
        lazy: () => import('./not-found'),
      },
    ],
  },
]);
